// @flow

export function addScrollLock(selector: string) {
  global.document.querySelector(selector).classList.add('scroll-lock');
}

export function removeScrollLock(selector: string) {
  global.document.querySelector(selector).classList.remove('scroll-lock');
}
